import { useEffect, useState } from 'react';
import { Icon } from '../common/icons'
import { StandardsDetailMapping } from './standardsDetailMapping';
import { StandardMapScale } from './standardMapScale';
import { getStaticAppSettings } from './../../utils/envService'

export default function StandardsList(props){

    const [ resultsArray, setResultsArray] = useState([])
    const [activeDetail, setActiveDetail] = useState(false)
    const [ indexFound, setIndexFound ] = useState(false)
    const [ resourcesFromDb, setResourcesFromDb ] = useState(true)
    const [ refreshDataLoading, setRefreshDataLoading ] = useState(false)
    const [ sectionStandards, setSectionStandards ] = useState([])
    const [ coverageAcceptance, setCoverageAcceptance ] = useState(0.6)
    const [ vectorAcceptance, setVectorAcceptance ] = useState(1.6)

    const { standard, generatingResults, demo, data, publisherFilter, setStandard, setGeneratingResults, setPageResults } = props;

    useEffect(() => {

        if(!refreshDataLoading){
            setIndexFound("0-0")
        }
    }, [refreshDataLoading])

    useEffect(() => {

        //GET STANDARDS

        // const newFilter = {...initialStandardFilter }
        // newFilter.curriculumSystemId = props.data.id === 6 ? 7 : props.data.id;

        // props.standardActions.getPublicStandards(newFilter, locale);

        getStaticAppSettings(process.env.NODE_ENV).then((settings) => {
            // Use your settings here
            getStandards(settings)
          });

      }, [data])

      useEffect(() => {

        setIndexFound("0-0")
      }, [standard])

      useEffect(() => {

        setStandard(false)

      },[publisherFilter])

      const getStandards = apiUrl => {

        const bodyToSend = {
            postalCode: data.code
        }

        // let headers = new Headers(authHeader())
        // headers.append('Content-type','application/json')

        // make a POST call to our api route
        return fetch(`${apiUrl.MAPPING_API_URL}/standards/standard-items`, {
        method: 'POST',
        headers: {
            "Content-Type": 'application/json',
          },
        body: JSON.stringify(bodyToSend)

        }) .then(response => {
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        // return response.json(); // This returns a promise
        console.log("response")
        })
        .then(data => {

        // setResults(data.sort((a,b) => b.score - a.score))
        // setGeneratingResults(false)
        })
        .catch(error => {
        console.error('There was a problem with the fetch operation:', error);

        // setResults(json.sort((a,b) => b.score - a.score))
        // console.log("results", json)
        // setGeneratingResults(false)
        })
        
      }


    const handleYearPlanChoice = (e, s) => {

        //GET UNITS FOR STANDARD AND setSectionStandards
                // const apiBaseUrl = `${config.apiUrl}Standards/GetUnitsForStandardMapping?standardId=${s.id}&publisherId=${parseInt(publisherFilter.userId,10)}`;
                // axios.get(apiBaseUrl, {
                //     headers: authHeader(),
                // }).then(response => {
            
                //     setSectionStandards(response.data)
            
                    
                // }).catch(function (error) {
                //     console.log('Looks like there was a problem: \n', error);
                
                // });
    
                // props.setStandard(s)
                // e && e.stopPropagation();
    }

    const clickDetail = (detail, results) => {

        setActiveDetail(detail)
        if(results){
        setPageResults(results.sort((a,b) => parseFloat(b.completionLevel) - parseFloat(a.completionLevel)))
        }
    }

            // const refreshDataForDetail = async (detail) => {
        //     try {
        
        //     //  e.preventDefault()
        //      setRefreshDataLoading(true)
        
          
        
        //      let subjectsList = []
        //      let yearsList = []
        //       if(standard){
        //      standard.listOfSubjects.forEach(s => {
        //       subjectsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
        //      })
        
        //      standard.listOfYearNumbers.forEach(s => {
        //       yearsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
        //      })
        //     }
        
        
        //      const bodyToSend = {
        //       subjectsFilter: subjectsList,
        //       yearGroupsFilter: yearsList,
        //       filterPublishers: publisherFilter.title,
        //       searchQuery: detail ? detail.description : " ",
        //       gptDemo: demo && publisherFilter.demo && publisherFilter.demo.find(d => d === demo) ? demo : null
        
        //      }
          
        //      // make a POST call to our api route
        //      let res = await fetch('/api/search', {
        //       method: 'POST',
        //       headers: {
        //        'Content-type': 'application/json',
        //       },
        //       body: JSON.stringify(bodyToSend)
            
        //      })
          
        //      if (res.ok) {
        //       const json = await res.json();
        //       // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/getReader
        //       if(json && json.results){
           
        //     //   setResults(json.results)
        //       console.log("results", json.results)

        //       const resultsArray = json.results.map(r =>{

        //         // const rId = parseInt(r.id.split("_")[1],10)-10000
        //         const rId = Math.round(Math. random() * (24200 - 24100) + 24100)

        //         console.log("rid", rId)

        //         const result = {
        //             resourceId: rId,
        //             nationalCurriculumObjectiveId: detail.id,
        //             score1: r.score,
        //             score2: parseFloat(r.completionLevel),
        //             explanation: r.completionExplanation
        //         }

        //         return result
        //       })

        //       console.log("resultsArray", resultsArray)


        //       const apiBaseUrl = `${config.apiUrl}CognitiveSearch/AddOrUpdateStandardsMapping`;
        //       axios.post(apiBaseUrl, resultsArray, {
        //           headers: authHeader(),
        //       }).then(response => {
                  
        //           console.log("done", response)
                  
        //       }).catch(function (error) {
        //           console.log('Looks like there was a problem: \n', error);
               
        //       });
              

              
        //      }
        //     }
           
          
        //       else {
        //       alert(`error getting response`)
        //     //   setGeneratingDetail(false)
        //      }
        //     } catch (error) {
        //      alert(`error: ${error.message}`)
        //     //  setGeneratingDetail(false)
        //     }
        //   }

      

        // const refreshData = async () => {
        //     try {
        
        //     //  e.preventDefault()
        //      setRefreshDataLoading(true)
        
        //      sections && sections[0].standardId === standard.id && sections.map(s => {

        //         s.details.map(async d => {

        //             await refreshDataForDetail(d)
        //         })
        //      })

        //      console.log("done")
        
        //     } catch (error) {
        //      alert(`error: ${error.message}`)
        //      setGeneratingDetail(false)
        //     }
        //   }

        const n = 20;

        return (

            <div>
                <div style={{position: 'absolute', top: '10rem', right: '2rem', display: 'flex', gap: '4rem', alignItems: 'center', justifyContent: 'space-between'}}>

                    {standard && <StandardMapScale coverageAcceptance={coverageAcceptance} setCoverageAcceptance={setCoverageAcceptance}/>}
                    <div style={{display: 'flex', gap: '1.2rem', alignItems: 'center', justifyContent: 'flex-end'}}>
                    {/* <div style={{display: 'flex', gap: '0.2rem', alignItems: 'center'}} className="body-2 ai-grey-100" onClick={() => setResourcesFromDb(prev => !prev)}>
                        {resourcesFromDb ? <Icon name='checkbox-checked' customClass="icon--medium" /> :  <Icon name='checkbox-unchecked' customClass="icon--medium" />}
                        <div className="body-2 ai-grey-100">Resources from db?</div>
                    </div> */}
                    {/* {standard &&
                    <div className="body-2 ai-grey-100" style={{display: 'flex', gap: '0.4rem'}}>
                        <div>Reranker threshold &#40;1 - 4.0&#41;:</div>
                        <input
                        className="body-2 ai-grey-100"
                        style={{paddingLeft: '0.2rem'}}
                            id="reranker"
                            type="number"
                            name="reranker"
                            step="0.1"
                            min="1"
                            max= "4"
                            value={vectorAcceptance}
                            onChange={(e) => setVectorAcceptance(parseFloat(e.target.value))}
                            required />
                    </div>
                    } */}
                    {/* <button className="round btn small primary-3" disabled={!(sectionStandards && sectionStandards.length > 0 && standard)}  onClick={() => setRefreshDataLoading(true)}>
                        <ButtonLoading loading={refreshDataLoading}>
                    <div className="button-text">Refresh</div>
                    </ButtonLoading>
                </button> */}
                </div>
              </div>
                
                    {props.loadingStandards

                    ?
                    <div className="gpt-standards__list">
                    {
                    [...Array(n)].map((e,i) => <div className="map__results--row-loading" key={i}><div></div></div>)
                    }
                     </div>
                    :
                    sectionStandards && sectionStandards.length > 0 && standard
                    
                    ?

                    <div className="gpt-standards__list">
                        <div className="gpt-standards__heading" onClick={() => props.setStandard(false)}>
                            <Icon name="chevron-left" customClass="icon--normal" />
                            <div className="body-large ai-grey-100">{standard.description}</div>
                        </div>

                        <div className="gpt-standards__list--inner">

      

                    {indexFound && sectionStandards && sectionStandards[0].standardId === standard.id && sectionStandards.map((s, sectionIndex) => {
                    
                        return(
                             <div className="gpt-standards__sections" key={s.id}>
                                <div className="ai-body-medium bold ai-grey-100">{s.description}</div>
                                <div className="gpt-standards__details">
                                {s.details.map((d,detailIndex) => {
                                    return(
                                        <div key={d.id}>
                                            <StandardsDetailMapping
                                            detail={d}
                                            standard={props.standards.find(st => st.id === s.standardId)}
                                            publisherFilter={publisherFilter}
                                            setPageResults={setPageResults}
                                            setGeneratingResults={setGeneratingResults}
                                            resultsArray={resultsArray}
                                            setResultsArray={setResultsArray}
                                            generatingDetail={generatingResults}
                                            clickDetail={clickDetail}
                                            activeDetail={activeDetail}
                                            index={`${sectionIndex}-${detailIndex}`}
                                            detailLength={s.details.length}
                                            setIndexFound={setIndexFound}
                                            indexFound={indexFound}
                                            demo={demo}
                                            resourcesFromDb={resourcesFromDb}
                                            refreshDataLoading={refreshDataLoading}
                                            setRefreshDataLoading={setRefreshDataLoading}
                                            finalIndex={`${sectionStandards.length-1}-${s.details.length-1}`}
                                            coverageAcceptance={coverageAcceptance}
                                            vectorAcceptance={vectorAcceptance}
                                            standardSection={s}
                                            user={props.user}
                                            />
                                        </div>
                                    )
                                })}
                                </div>
                                 
                            </div>
                        )
                    })}

    </div>

                </div>
                :


                <div className="gpt-standards__list">

                {props.standards && props.standards.filter(st => st.listOfSubjects.find(su => publisherFilter.subjectIds.includes(su.id))).map(s => {
                
                    return(
                         <div className="ai-body-medium bold ai-grey-100 standards__row" key={s.id} onClick={(e) => handleYearPlanChoice(e,s)}>
                         
                                <div className="ai-body-medium bold ai-grey-100">{s.description}</div>
                            </div>
                    )
                })}
             

            </div>
}




            </div>
        );
    

}